module.exports = __webpack_public_path__ + "/login_ui/img/pe-935d1c42350df0dae813d1047c69e8df.svg";